import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { SidebarInset, SidebarProvider, useSidebar } from '@/components/ui/sidebar';
import { Header } from '@/components/layout/Header';
import { AppSidebar } from '@/components/layout/Sidebar';

const SIDEBAR_STORAGE_KEY = 'sideBarStatus';

function MainLayoutContent() {
  const { setOpenMobile, state } = useSidebar();

  const handleMenuClick = () => {
    setOpenMobile(true);
  };

  const isExpanded = state === 'expanded';

  return (
    <>
      <Header onMenuClick={handleMenuClick} />
      <AppSidebar />
      <SidebarInset className={`mt-[66px] ${isExpanded ? 'w-[calc(100%-210px)]' : 'w-[calc(100%-3rem)]'}`}>
        <Outlet />
      </SidebarInset>
    </>
  );
}

export function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    const stored = localStorage.getItem(SIDEBAR_STORAGE_KEY);
    return stored === 'true' || stored === null;
  });

  const handleSidebarOpenChange = (open: boolean) => {
    setSidebarOpen(open);
    localStorage.setItem(SIDEBAR_STORAGE_KEY, String(open));
  };

  return (
    <SidebarProvider open={sidebarOpen} onOpenChange={handleSidebarOpenChange}>
      <MainLayoutContent />
    </SidebarProvider>
  );
}
